// Período dos dashboards: dias inteiros de São Paulo, último dia incluído, como o servidor espera
// (?de=AAAA-MM-DD&ate=AAAA-MM-DD).

export type Atalho = '7' | '30' | '90' | '365' | 'livre'

// 12 meses: o período que o Power BI da AG abria por padrão (E19).
export const ROTULO_ATALHO: Record<Atalho, string> = {
    '7': '7 dias',
    '30': '30 dias',
    '90': '90 dias',
    '365': '12 meses',
    livre: 'Escolher datas'
}

export type Periodo = { de: string; ate: string }

/** Hoje em São Paulo, AAAA-MM-DD. */
export function hojeEmSaoPaulo(agora = new Date()): string {
    return agora.toLocaleDateString('en-CA', { timeZone: 'America/Sao_Paulo' })
}

export function somarDias(dia: string, dias: number): string {
    const data = new Date(`${dia}T00:00:00Z`)
    data.setUTCDate(data.getUTCDate() + dias)
    return data.toISOString().slice(0, 10)
}

/** Os últimos N dias até hoje, hoje incluído. */
export function periodoDoAtalho(atalho: Exclude<Atalho, 'livre'>, hoje = hojeEmSaoPaulo()): Periodo {
    return { de: somarDias(hoje, -(Number(atalho) - 1)), ate: hoje }
}

/** Qual atalho corresponde ao período, ou 'livre'. */
export function atalhoDoPeriodo(periodo: Periodo, hoje = hojeEmSaoPaulo()): Atalho {
    for (const atalho of ['7', '30', '90', '365'] as const) {
        const p = periodoDoAtalho(atalho, hoje)
        if (p.de === periodo.de && p.ate === periodo.ate) return atalho
    }
    return 'livre'
}

/** 2026-10-22 → 22/10 (ou 22/10/2026 com ano). */
export function formatarDia(dia: string, comAno = false): string {
    const [ano, mes, d] = dia.split('-')
    return comAno ? `${d}/${mes}/${ano}` : `${d}/${mes}`
}
